import {PATH_GET_MENU} from 'constants/AppPath';
import {Utils} from 'services/common/utils';
import {APP_CODE} from "../../constants/AppProps";
import {GET_COMMON_USER_INFOR} from "../../constants/AppPath";
import {AuthenticationService} from "./AuthenticationService";

export const UserService = {
    getMenu,
    getUserInfor
};

async function getMenu() {
    let pMenu = await Utils.get(PATH_GET_MENU, {
        "appId": APP_CODE,
        "userId": AuthenticationService.currentUserValue.userId
    }, null, true);
    if (pMenu && pMenu.data && pMenu.data.body && pMenu.data.body.tree && pMenu.data.body.flat) {
        return pMenu.data.body;
    }
    return null;
}

async function getUserInfor() {
    let uInfor = await Utils.get(GET_COMMON_USER_INFOR, {"userId": AuthenticationService.currentUserValue.userId}, null, true);
    if (uInfor && uInfor.data) {
        return uInfor.data;
    }
    return null;
}